<template>
  <div class="modal-card modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Items By {{ itemsBy }}</p>
      <button type="button" class="delete" @click="$parent.close()" />
    </header>
    <section class="modal-card-body">
      <strong>Displaying First {{ pageSize }} Items out of {{ count }}</strong>
      <br />
      <table width="50%">
        <tr>
          <td width="20%">
            <option v-for="vcat in vcatList" :value="cas" :key="vcat.id">
              {{ vcat }}
            </option>
          </td>
        </tr>
      </table>
    </section>
    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        Close
      </button>
    </footer>
  </div>
</template>

<script>
export default {
  name: "CasItems",
  props: ["vcatList", "count", "pageSize", "itemsBy"],
  data() {
    return {
      classes: "",
      cas: ""
    };
  }
};
</script>

<style scoped></style>
